import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getProducts = () => axios.get(`${API}/products`).then((r) => r.data);

export const createCheckout = (payload) =>
  axios.post(`${API}/payments/checkout`, payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const sendContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const fmtEuro = (n) =>
  new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(n);

const VOLUME_UNIT = 39;

// Cart-wide volume price for the total number of pods (any combination).
export const comboPrice = (n) => {
  if (n <= 0) return 0;
  if (n === 1) return 39;
  if (n === 2) return 69;
  return (9500 + 3166 * (n - 3)) / 100; // 3 -> 95, 4 -> 126.66, 5 -> 158.32, ...
};

// Returns pricing breakdown across the cart. The Complete Package counts as 3 pods.
export const cartPricing = (items) => {
  let podCount = 0, otherTotal = 0;
  for (const i of items) {
    const units = i.pod_units || 0;
    if (units) podCount += i.quantity * units;
    else otherTotal += i.price * i.quantity;
  }
  const individualFull = podCount * VOLUME_UNIT;
  const individualDiscounted = comboPrice(podCount);
  return { individualQty: podCount, individualFull, individualDiscounted, otherTotal, total: individualDiscounted + otherTotal };
};
